import { render, staticRenderFns } from "./settings-account.vue?vue&type=template&id=874082ce&scoped=true"
import script from "./settings-account.vue?vue&type=script&lang=js"
export * from "./settings-account.vue?vue&type=script&lang=js"
import style0 from "./settings-account.vue?vue&type=style&index=0&id=874082ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874082ce",
  null
  
)

export default component.exports